import React from "react";
import "../../../styles/Banner.css";
import Image from "../../../assets/img/H1.png";
import Image2 from "../../../assets/img/H2.png";
import { useNavigate } from "react-router-dom";

const BannerIndex = ({ aboutRef }) => {
  const navigate = useNavigate();
  const scrollToAbout = () => {
    if (aboutRef?.current) {
      aboutRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  

  return (
    <div className="banner">
      {/* Izquierda */}
      <div className="banner-left">
        <h1>BILLY</h1>
        <h1>BROWNS</h1>
        <div>
          <p className="text-orange text-center">¡Bienvenido!</p>
          <p>Arma tu billy en pocos pasos</p>
        </div>
        <div className="banner-buttons">
          <button
            className="btn-cta p-3"
            onClick={() => {
              navigate("/login");
            }}
          >
            Armar hamburguesa
          </button>
          <button className="btn-cta p-3" onClick={scrollToAbout}>
            Conoce más
          </button>
        </div>
      </div>

      {/* Imagen central */}
      <div className="banner-center position-absolute">
        <img src={Image} alt="Imagen Central" />
      </div>

      {/* Derecha */}
      <div className="banner-right">
        <div className="size-selector">
          <div className="size-circle">S</div>
          <div className="size-circle">M</div>
          <div className="size-circle">L</div>
          <div className="size-circle">XL</div>
        </div>
        <img src={Image2} alt="Imagen Derecha" />
      </div>
    </div>
  );
};

export default BannerIndex;
